<template>
  <div class="chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';
import outlabels from 'chartjs-plugin-piechart-outlabels';

Chart.plugins.unregister(outlabels);
Chart.plugins.register(outlabels);

export default {
  name: 'PieChart',
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      new Chart(this.$refs.canvas, {
        type: 'pie',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            }
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 30
            }
          },
          plugins: {
            outlabels: {
              text: '%l %v (%p)',
              color: 'black',
              backgroundColor: 'transparent',
              stretch: 15,
              font: {
                resizable: true,
                minSize: 11,
                maxSize: 11
              },
              lineColor: 'black',
              lineWidth: 1
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>

.chart-container {
  position: relative;
  width: 100%;
  height: 90%;
}

</style>
